import { useState } from "react";

/**
 * Shared expand/collapse state for tables with nested child rows (e.g. an office
 * row expanding to show its warehouses, or a location expanding to show its child
 * facilities like port terminals). Keyed by whatever id the caller uses for a row.
 */
export const useExpandableRows = () => {
  const [expandedRows, setExpandedRows] = useState(new Set());

  const isExpanded = (id) => expandedRows.has(id);

  const toggleExpand = (id) => setExpandedRows((prev) => {
    const next = new Set(prev);
    next.has(id) ? next.delete(id) : next.add(id);
    return next;
  });

  return { isExpanded, toggleExpand };
};
